var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualTour({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.096,
    height: 41.096,
    viewBox: "0 0 41.096 41.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M43.55,37.774a1.126,1.126,0,0,0,0-1.512C43.2,35.872,34.821,27.1,24.233,27.1S5.262,35.872,4.917,36.218a1.126,1.126,0,0,0,0,1.512c.346.389,8.729,9.161,19.317,9.161S43.2,38.119,43.55,37.774Zm-19.316,6.05A6.828,6.828,0,1,1,31.061,37,6.842,6.842,0,0,1,24.233,43.824Zm-6.223-13.4A9.068,9.068,0,0,0,15.158,37a8.9,8.9,0,0,0,2.852,6.568A32.109,32.109,0,0,1,7.337,37,31.873,31.873,0,0,1,18.01,30.427ZM30.456,43.564A9.068,9.068,0,0,0,33.308,37a8.9,8.9,0,0,0-2.852-6.568A31.414,31.414,0,0,1,41.13,37,31.873,31.873,0,0,1,30.456,43.564Z",
    transform: "translate(-3.707 -16.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M44.378,40a4.353,4.353,0,0,0-1.858.432,1.541,1.541,0,0,1-.562,2.982,1.494,1.494,0,0,1-1.426-.994,4.509,4.509,0,0,0-.432,1.858,4.321,4.321,0,1,0,8.643,0A4.392,4.392,0,0,0,44.378,40Z",
    transform: "translate(-23.852 -23.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M3.624,16.372a1.144,1.144,0,0,0,1.124-1.124V4.747h10.76a1.144,1.144,0,0,0,1.124-1.124A1.144,1.144,0,0,0,15.507,2.5H3.624A1.144,1.144,0,0,0,2.5,3.624V15.248A1.144,1.144,0,0,0,3.624,16.372Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M77.864,2.5H66.024A1.144,1.144,0,0,0,64.9,3.624a1.144,1.144,0,0,0,1.124,1.124h10.76v10.5a1.124,1.124,0,1,0,2.247,0V3.624A1.214,1.214,0,0,0,77.864,2.5Z",
    transform: "translate(-37.935 -2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M77.864,65.4a1.144,1.144,0,0,0-1.124,1.124V77.068H66.024a1.124,1.124,0,1,0,0,2.247H77.864a1.144,1.144,0,0,0,1.124-1.124V66.524A1.144,1.144,0,0,0,77.864,65.4Z",
    transform: "translate(-37.935 -38.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M15.464,77.024H4.747v-10.5A1.144,1.144,0,0,0,3.624,65.4,1.144,1.144,0,0,0,2.5,66.524V78.148a1.144,1.144,0,0,0,1.124,1.124H15.464a1.124,1.124,0,1,0,0-2.247Z",
    transform: "translate(-2.5 -38.219)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualTour);
export default __webpack_public_path__ + "static/media/virtualTour.7c5f7d0a7b1855831cf9160962793249.svg";
export { ForwardRef as ReactComponent };